module.exports = __webpack_public_path__ + "static/media/2018진짜공부_popup.c8e52fdb.png";